.kp{gap:0.125rem;}